module.exports = __webpack_public_path__ + "static/media/landingTile3.1a0b4d63.png";